import React, { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import DataStore from '@leverege/data-store/lib/web/browser.js';
import I18N from '@leverege/i18n';
import { DataSources } from '@leverege/ui-attributes';
import { Flex, Text, Toast } from '@leverege/ui-elements';
import { Toolbar } from '@leverege/ui-plugin';
import { GlobalState } from '@leverege/ui-redux';
import { isTagInGatewayRange, isTagRingCommandSent, isTagRinging, isTagWaitingForDetection } from './Util.js';
import C from './Constants.js';
import S from './FindAssetDetailRenderer.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const {
  t
} = I18N.ns('recovr.details.findAsset.FindAssetDetailRenderer');
const EMPTY = {};
const client = 'DataCardDetail';
export default class FindAssetDetailRenderer {
  constructor(model) {
    this.model = model;
  }
  getValueComponent(object, cxt, ...rest) {
    const {
      type
    } = object;
    const context = {
      ...cxt,
      client,
      clientProps: {
        ...cxt.clientProps,
        settings: {
          type: 'findAsset'
        }
      }
    };
    const matchContext = {
      use: 'actionBar',
      objectType: type,
      client
    };
    return /*#__PURE__*/_jsx(ManagedValueComponent, {
      asset: object?.id,
      assetObjRef: object,
      context: context,
      matchContext: matchContext,
      model: this.model
    });
  }
  getComponents(object, cxt = EMPTY, ...rest) {
    return [{
      style: {
        padding: '0px'
      },
      component: this.getValueComponent(object, cxt)
    }];
  }
}
function PairedAssetInGatewayRange({
  assetName,
  context,
  matchContext,
  model
}) {
  return /*#__PURE__*/_jsxs(Flex, {
    className: S.row,
    style: model.style,
    align: "center",
    justify: "space-between",
    variant: "pairDetail",
    children: [/*#__PURE__*/_jsxs(Flex, {
      variant: "colM",
      className: S.label,
      children: [/*#__PURE__*/_jsx(Text, {
        className: S.title,
        children: t('pairedAssetInGatewayRangeTitle', {
          assetName
        })
      }), /*#__PURE__*/_jsx(Text, {
        className: S.subtitle,
        children: t('pairedAssetInGatewayRangeSubtitle')
      })]
    }), /*#__PURE__*/_jsx("div", {
      className: S.value,
      children: /*#__PURE__*/_jsx(Toolbar, {
        variant: "secondary",
        context: context,
        matchContext: matchContext
      })
    })]
  });
}
function PairedAssetOutOfGatewayRange({
  context,
  matchContext,
  model
}) {
  return /*#__PURE__*/_jsxs(Flex, {
    className: S.row,
    style: model.style,
    align: "center",
    justify: "space-between",
    variant: "pairDetail",
    children: [/*#__PURE__*/_jsxs(Flex, {
      variant: "colM",
      children: [/*#__PURE__*/_jsx(Text, {
        className: S.title,
        children: t('pairedAssetOutOfGatewayRangeTitle')
      }), /*#__PURE__*/_jsx(Text, {
        className: S.subtitle,
        children: t('pairedAssetOutOfGatewayRangeSubtitle')
      })]
    }), /*#__PURE__*/_jsx("div", {
      className: S.value,
      children: /*#__PURE__*/_jsx(Toolbar, {
        context: context,
        matchContext: matchContext
      })
    })]
  });
}
function UnpairedAsset({
  context,
  matchContext,
  model
}) {
  return /*#__PURE__*/_jsxs(Flex, {
    className: S.row,
    style: model.style,
    align: "center",
    justify: "space-between",
    variant: "pairDetail",
    children: [/*#__PURE__*/_jsxs(Flex, {
      variant: "colM",
      children: [/*#__PURE__*/_jsx(Text, {
        className: S.title,
        children: t('unpairedAssetTitle')
      }), /*#__PURE__*/_jsx(Text, {
        className: S.subtitle,
        children: t('unpairedAssetSubtitle')
      })]
    }), /*#__PURE__*/_jsx("div", {
      className: S.value,
      children: /*#__PURE__*/_jsx(Toolbar, {
        context: context,
        matchContext: matchContext
      })
    })]
  });
}
function PairedAssetConnecting({
  assetName,
  context,
  matchContext,
  model
}) {
  return /*#__PURE__*/_jsxs(Flex, {
    className: S.row,
    style: model.style,
    align: "center",
    justify: "space-between",
    variant: "pairDetail",
    children: [/*#__PURE__*/_jsxs(Flex, {
      variant: "colM",
      children: [/*#__PURE__*/_jsx(Text, {
        className: S.title,
        children: t('pairedAssetConnectingTitle', {
          assetName
        })
      }), /*#__PURE__*/_jsx(Text, {
        className: S.subtitle,
        children: t('pairedAssetConnectingSubtitle')
      })]
    }), /*#__PURE__*/_jsx("div", {
      className: S.value,
      children: /*#__PURE__*/_jsx(Toolbar, {
        variant: "primary",
        context: context,
        matchContext: matchContext
      })
    })]
  });
}
function PairedAssetRequestSent({
  assetName,
  tagId,
  context,
  matchContext,
  model
}) {
  return /*#__PURE__*/_jsxs(Flex, {
    className: S.row,
    style: model.style,
    align: "center",
    justify: "space-between",
    variant: "pairDetail",
    children: [/*#__PURE__*/_jsxs(Flex, {
      variant: "colM",
      children: [/*#__PURE__*/_jsx(Text, {
        className: S.title,
        children: t('pairedAssetRequestSentTitle', {
          tagId
        })
      }), /*#__PURE__*/_jsx(Text, {
        className: S.subtitle,
        children: t('pairedAssetRequestSentSubtitle', {
          assetName
        })
      })]
    }), /*#__PURE__*/_jsx("div", {
      className: S.value,
      children: /*#__PURE__*/_jsx(Toolbar, {
        context: context,
        matchContext: matchContext
      })
    })]
  });
}
function PairedAssetRinging({
  assetName,
  tagId,
  context,
  matchContext,
  model
}) {
  return /*#__PURE__*/_jsxs(Flex, {
    className: S.row,
    style: model.style,
    align: "center",
    justify: "space-between",
    variant: "pairDetail",
    children: [/*#__PURE__*/_jsxs(Flex, {
      variant: "colM",
      children: [/*#__PURE__*/_jsx(Text, {
        className: S.title,
        children: t('pairedAssetRingingTitle', {
          tagId
        })
      }), /*#__PURE__*/_jsx(Text, {
        className: S.subtitle,
        children: t('pairedAssetRingingSubtitle', {
          assetName
        })
      })]
    }), /*#__PURE__*/_jsx("div", {
      className: S.value,
      children: /*#__PURE__*/_jsx(Toolbar, {
        context: context,
        matchContext: matchContext
      })
    })]
  });
}
function ManagedValueComponent({
  assetObjRef,
  context,
  matchContext,
  model
}) {
  const delegate = DataSources.getDelegate(assetObjRef);
  const asset = useSelector(state => delegate.getItem(state));
  const prevAsset = useRef(asset);
  const tag = asset?.data?.tag;
  const assetName = asset?.name || asset?.data?.name;
  const tagId = tag?.data?.serialNumber || tag?.id;
  const dataStore = useRef();
  const dataStoreTimeout = useRef();
  const onData = async snapshot => {
    // const data = snapshot.val()

    // Waiting for es propagation. delegate.get() pulls from es.
    await new Promise(resolve => {
      setTimeout(resolve, 2000);
    });

    // Instantiate asset item delegate.
    const delegate = DataSources.getDelegate(assetObjRef);

    // Only way to get the custom renderer to re-render programatically.
    await GlobalState.dispatch(delegate.get()).then(asset => {
      // If the asset ring command state changes from something else to 'failed', display error toast.
      if (asset?.data?.tag?.data?.commands?.ring?.state === C.TAG_RING_COMMAND_STATES.FAILED && prevAsset.current?.data?.tag?.data?.commands?.ring?.state !== C.TAG_RING_COMMAND_STATES.FAILED) {
        Toast.error(t('commandFailed'));
      }

      // If the asset ring command state changes from 'waitingForDetection' to empty, display error toast.
      if (asset?.data?.tag?.data?.commands?.ring?.state == null && prevAsset.current?.data?.tag?.data?.commands?.ring?.state === C.TAG_RING_COMMAND_STATES.WAITING_FOR_DETECTION) {
        Toast.error(t('commandNotSent'));
      }
      prevAsset.current = asset;
    });
  };
  const stopListener = () => {
    if (dataStore.current) {
      clearTimeout(dataStoreTimeout.current);
      dataStore.current.off('', onData);
    }
  };
  const startListener = async () => {
    if (!dataStore.current) {
      // Instantiate asset item delegate.
      const delegate = DataSources.getDelegate(assetObjRef);

      // Get imagine device from firebase.
      const firebaseImagineDevice = await GlobalState.dispatch(delegate.get({
        blueprint: true,
        accessToken: true
      }));

      // Listen for device updates.
      dataStore.current = DataStore.createDatabase(firebaseImagineDevice.accessToken);
      await dataStore.current.signIn(firebaseImagineDevice.accessToken.jwt);
      dataStore.current.on('', onData);

      // Turn off listener after 2 minutes.
      clearTimeout(dataStoreTimeout.current);
      dataStoreTimeout.current = setTimeout(stopListener, C.WAITING_FOR_DETECTION_MAX_DURATION_MS + C.WAITING_FOR_RESPONSE_MAX_DURATION_MS);
    }
  };
  const onCommand = async () => {
    // Turn on listener.
    startListener();

    // Turn off listener after 2 minutes.
    dataStoreTimeout.current = setTimeout(stopListener, C.WAITING_FOR_DETECTION_MAX_DURATION_MS + C.WAITING_FOR_RESPONSE_MAX_DURATION_MS);
  };
  useEffect(() => {
    if (tag?.data?.commands?.ring?.state) {
      // Turn on listener on mount.
      startListener();
    }

    // Turn off listener on unmount.
    return stopListener;
  }, [tag]);
  if (tag) {
    if (isTagWaitingForDetection(tag)) {
      return /*#__PURE__*/_jsx(PairedAssetConnecting, {
        assetName: assetName,
        context: {
          ...context,
          onCommand
        },
        matchContext: matchContext,
        model: model
      });
    }
    if (isTagRingCommandSent(tag)) {
      return /*#__PURE__*/_jsx(PairedAssetRequestSent, {
        assetName: assetName,
        tagId: tagId,
        context: {
          ...context,
          onCommand
        },
        matchContext: matchContext,
        model: model
      });
    }

    // Ringing lasts for 30 seconds. 5 seconds buffer was requested by product/design team because reasons.
    if (isTagRinging(tag)) {
      return /*#__PURE__*/_jsx(PairedAssetRinging, {
        assetName: assetName,
        tagId: tagId,
        context: {
          ...context,
          onCommand
        },
        matchContext: matchContext,
        model: model
      });
    }
    if (isTagInGatewayRange(tag)) {
      return /*#__PURE__*/_jsx(PairedAssetInGatewayRange, {
        assetName: assetName,
        context: {
          ...context,
          onCommand
        },
        matchContext: matchContext,
        model: model
      });
    }
    return /*#__PURE__*/_jsx(PairedAssetOutOfGatewayRange, {
      context: {
        ...context,
        onCommand
      },
      matchContext: matchContext,
      model: model
    });
  }
  return /*#__PURE__*/_jsx(UnpairedAsset, {
    context: {
      ...context,
      onCommand
    },
    matchContext: matchContext,
    model: model
  });
}